module.exports = __webpack_public_path__ + "static/media/bg-what-we-do-small.36a7b062.svg";